export const CLICK_TYPE = {
  SELECT: 'SELECT',
  DESELECT: 'DESELECT',
};

export const TYPES_DROPDOWN_VALUES = [
  {
    value: 'link',
    text: 'Link',
  },
  {
    value: 'service',
    text: 'Service',
  },
  {
    value: 'experience',
    text: 'Experience',
  },
];
